export default __webpack_public_path__ + "static/media/visa-blue.c09b795c.svg";